import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { finalize } from "rxjs";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.css"
})
export class ResetPasswordComponent {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  isBusy = false;
  error = "";
  message = "";
  hasToken = false;
  private accessToken = "";
  private refreshToken = "";

  readonly form = this.fb.nonNullable.group({
    password: ["", [Validators.required, Validators.minLength(6)]],
    confirm: ["", [Validators.required, Validators.minLength(6)]]
  });

  constructor() {
    this.readTokens();
  }

  submit() {
    if (this.form.invalid || this.isBusy || !this.hasToken) {
      return;
    }

    const value = this.form.getRawValue();
    if (value.password !== value.confirm) {
      this.error = "Passwords do not match.";
      return;
    }

    this.isBusy = true;
    this.error = "";
    this.message = "";

    this.authService
      .confirmPasswordReset(this.accessToken, this.refreshToken, value.password)
      .pipe(finalize(() => (this.isBusy = false)))
      .subscribe({
        next: (result) => {
          this.message = result.message;
          void this.router.navigateByUrl("/dashboard");
        },
        error: (error) => {
          this.error = error?.error?.message || error?.message || "Failed to update password";
        }
      });
  }

  private readTokens() {
    if (typeof window === "undefined") {
      return;
    }

    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const searchParams = new URLSearchParams(window.location.search);
    const type = hashParams.get("type") || searchParams.get("type");
    this.accessToken = hashParams.get("access_token") || "";
    this.refreshToken = hashParams.get("refresh_token") || "";

    if (type === "recovery" && this.accessToken && this.refreshToken) {
      this.hasToken = true;
    } else {
      this.error = "Invalid or expired reset link.";
      this.hasToken = false;
    }
  }
}
